export enum Feature {
  ActionableTaskView = 'Actionable Task View',
  AutomaticReports = 'Automatic Reports',
  AutoProvisioningSpotlight = 'AutoProvisioningSpotlight',
  BlockTeamlessBoards = 'Block Teamless Boards',
  BoardsPageTemplatePicker = 'Boards Page Template Picker',
  BoardTile = 'Board Tile',
  BoardViewsButton = 'Board Views Switcher',
  ButlerOnBoards = 'Butler on Boards',
  CalendarView = 'Calendar View',
  CardDetailDialog = 'Card Detail Dialog',
  CardFrontLinks = 'Card Front Links',
  CardTemplates = 'Card Templates',
  Checklists = 'Checklists',
  Collections = 'Collections',
  CovidChurn = 'Covid Churn',
  CreateBoardPopover = 'Create Board Popover',
  CrossProductSearch = 'Cross Product Search',
  EnterpriseAuditLogSheetsExport = 'Enterprise Audit Log Sheets Export',
  FreeTrialExistingTeam = 'Free Trial Existing Team',
  ExpiredFreeTrialExistingTeam = 'Expired Free Trial Existing Team',
  LinkCard = 'Link Card',
  LinkCardLoadAnalysis = 'Link Card Load Analysis',
  Madlibs = 'Madlibs',
  MarkdownTracker = 'Markdown Tracker',
  MemberBoardsPage = 'Member Boards Page',
  MigrationWizard = 'Migration Wizard',
  Moonshot = 'moonshot',
  MultiBoardTableView = 'Multi-Board Table View',
  NavigationMoreMenu = 'Navigation More Menu',
  NuSkuBillingView = 'NuSku Billing View',
  PDFRenderer = 'PDF Renderer',
  PluginPermissions = 'Plugin Permissions',
  ProjectBrita = 'Project Brita',
  ProfileCard = 'Profile Card',
  PushTouchpointsSwitcherSpotlight = 'PushTouchpointsSwitcherSpotlight',
  RecentlyViewedBoardsMenu = 'Recently Viewed Boards Menu',
  SavedViews = 'Saved Views',
  SmartLink = 'Smart Link',
  StarredBoardsMenuButton = 'Starred Boards Menu Button',
  AutoRenewal = 'Auto Renewal',
  TableView = 'Table View',
  TeamfulCollaborationAddPeople = 'Teamful Collaboration Add People',
  TeamEditAvatar = 'Team Edit Avatar',
  TeamOnboarding = 'Team Onboarding',
  TeamProfile = 'Team Profile Header',
  TeamTemplatePicker = 'Team Template Picker',
  TemplateCard = 'Template Card',
  TemplatePicker = 'Template Picker',
  TemplatesGallery = 'Templates Gallery',
  TemplatesInCreateFlow = 'Templates In Create Flow',
  TemplatesMenu = 'Templates Menu',
  TemplateTips = 'Template Tips',
  Theme = 'Theme',
  TimelineView = 'Timeline View',
  UndoAction = 'Undo Action',
  UpgradePrompt = 'Upgrade Prompt',
  WorkspaceBoardsPage = 'Workspace Boards Page',
  ViewSuggestionUpsell = 'View Suggestion Upsell Banner',
  WorkspaceNavigation = 'Workspace Navigation',
  WorkspaceSwitcher = 'Workspace Switcher',
  WorkspacesAutoNameAlert = 'Workspaces Auto Name Alert',
  WorkspaceDefaultCustomTableView = 'Workspace Default Custom Table View',
  WorkspaceViews = 'Workspace Views',
}
